import Enum from "../../../enums/Enum";

const DirectBillingObservationTypeEnum = new Enum({
    TEXT: {name: "Text"},
    FILE: {name: "File"},
    FLAG: {name: "Flag"}
});

export default DirectBillingObservationTypeEnum;
